import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './OccurrenceOfflineManager.html?raw';
// NOTE (JS2TS): dropped dead deps (dojo/on, dom-construct, dom-style, dojo/date/locale — not used;
// moreCore/UI/GenericDialog/GenericDialog — imported but never used in code and not referenced in the template).
// xstyle/css!./OccurrenceList.css was already commented out.

class OccurrenceOfflineManager extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    data: any = null;

    analyzeData(): void {

        if (this.data == null) {
            topic.publish("/OfflineManager/Message", false, this.translations["OccurrenceOfflineManager_NoData"]);
            return;
        }

        topic.publish("/OfflineManager/Message", false, "ready");
    }


    _onOfflineOnlineChanged(): void {
        domClass.remove(this.connectionStatus, "w3-text-green w3-text-red w3-pale-red");
        domAttr.set(this.connectionStatusLabel, "innerHTML", "");

        if (navigator.onLine == true) {
            this.online = true;

            domClass.add(this.connectionStatus, "w3-text-green mds-bg-gray");
            domAttr.set(this.connectionStatusLabel, "innerHTML", this.translations["General_Online"]);

        } else {
            this.online = false;

            domClass.add(this.connectionStatus, "w3-text-red w3-pale-red");
            domAttr.set(this.connectionStatusLabel, "innerHTML", this.translations["General_Offline"]);
        }

        topic.publish("/OfflineManager/OfflineStateChange");
    }



    _setupSubscriptions(): void {

        window.addEventListener('online', lang.hitch(this, "_onOfflineOnlineChanged"));
        window.addEventListener('offline', lang.hitch(this, "_onOfflineOnlineChanged"));

    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(data?: any): void {
        super.startup.apply(this, arguments as any);

        this.analyzeData();
        this._onOfflineOnlineChanged();

    }
}
OccurrenceOfflineManager.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceOfflineManager';

export default mdsWidget(OccurrenceOfflineManager);
